import 'angular-resource'
import AddOns from './AddOns.resource'
import Billing from './Billing.resource'
import BillingService from './BillingService'
import Datasets from './Datasets.resource'
import Subscription from './Subscription.resource'
import SubscriptionService from './SubscriptionService'
import Plans from './Plans.resource'
import ngMessages from 'angular-messages'
import register from '../util/register'

var billing = angular.module(
  'app.billing',
  [
    'ngMessages',
    'ngResource',
    'ui.bootstrap'
  ]
)

register('app.billing')
  .service('BillingService', BillingService)
  .service('SubscriptionService', SubscriptionService)
  .factory('Billing', Billing.factory)
  .factory('Datasets', Datasets.factory)
  .factory('Subscription', Subscription.factory)
  .factory('Plans', Plans.factory)
  .factory('AddOns', AddOns.factory)

billing.run()
